import React from 'react'
import { withRouter } from 'react-router'
import { observer } from 'mobx-react'
import { Col, Container, Row } from 'react-bootstrap'
import { runInAction, observable } from 'mobx'
import {
  getCookie,
  useStickyTop,
  QUALIFICATION_URL,
  APPConfig,
  getAppConfig,
  convertToBoolean,
} from 'config/appConfig'
import { application, enableNewFeature } from 'src/utils'
import {
  customerContainer,
  footerContainer,
  contentStackContainer,
} from 'src/models'
import { pageNames } from 'src/routes/pathParams'
import {
  getLocaleCodeFromUrl,
  ApiContent,
  IS_BROWSER,
  i18nTranslate,
  isToShowOverrideSubscription,
  serializeNavigationPathRecords,
  writeBreadcrumbSessionRecord,
  getBreadcrumbSessionRegion,
} from 'src/utils'
import { CommonHeader } from '../CommonHeader'
import TopNotice from './TopNotice'
import SearchSection from './SearchSection'
import MegaMenuSection from './MegaMenuSection'
import ScrollingInfoSection from './ScrollingInfoSection'
import LocaleSection from './LocaleSection'
import leadership from 'src/images/Leadership.png'
import ContentStack from 'src/api/contentStack'
import { SkipLink } from '../Components'
import { KlarnaMessage, KlarnaScript } from 'src/views/components/KlarnaMessage'
import { isHomePage } from '../../KlarnaMessage/KlarnaMessage'
import { shouldSuppressHeaderAndModals } from '../deps'
import { HeaderMarketing } from './HeaderMarketing'
import { searchState } from 'src/views/components/Header/Components/SearchBox/SearchState'
import { mysiteContainer } from 'src/models/Mysite'
import TopRibbon from '../Components/TopRibbon/TopRibbon'
import { transformContentStackToMenuData } from 'src/models/ContentStack/transform'
import MysiteShopHeader from '../MysiteShopHeader'
import { isEquinoxMysite, isEquinoxPOSite } from 'src/utils/mySiteUtils'
import { personalOfferContainer } from 'src/models/PersonalOffer'
import './styles.scss'

@observer
class NuskinHeader extends CommonHeader {
  nameSpace = 'ssr-resource'
  @observable data = []
  @observable topNotice = {}
  @observable scrollingInfo = []
  @observable headerLogoUrl = ''
  @observable headerData = {
    topRibbon: [],
    headerNavigation: {
      link: { title: '', href: '' },
      usd_label: '',
    },
    regionSelector: {},
    searchData: {},
    navigationData: {},
  }

  scrollState = {
    headerType: 'full-view',
    lastPosition: 0,
    isScrolling: false,
    zoom: 1,
    threshold: 75,
    deviceType: 'desktop',
    viewportWidth: 0,
    isTouchDevice: false,
    element: null,
    rafId: null,
    lastHeaderHeight: 0,
    timeouts: {
      debounce: null,
      update: null,
      stop: null,
    },
  }

  static contextType = ApiContent
  mysiteHeaderObserved = false
  constructor(props, context) {
    super(props, context)
    this.currentLocale = getLocaleCodeFromUrl({
      locationProps: props,
      at: 'pathParam',
      defaultLocale: 'en_US',
      isReverseType: true,
    })
    this.context = context
    this.contextName = 'marketingData'
    this.headerEntryContextName = 'csHeaderEntry'
    this.getDataFromSource()
    this.getHeaderEntryFromSource()
    this.initializeScrollState()
  }

  initializeScrollState = () => {
    if (!IS_BROWSER) return

    this.scrollState.viewportWidth = window.innerWidth
    this.scrollState.isTouchDevice =
      'ontouchstart' in window || navigator.maxTouchPoints > 0

    let zoom = window.devicePixelRatio || 1
    if (zoom === 1 && screen.width && window.innerWidth) {
      zoom = screen.width / window.innerWidth
    }
    if (zoom === 1 && window.outerWidth && window.innerWidth) {
      zoom = window.outerWidth / window.innerWidth
    }
    this.scrollState.zoom = Math.max(0.5, Math.min(3, zoom))

    const appDeviceType = application?.deviceType
    if (appDeviceType) {
      this.scrollState.deviceType =
        appDeviceType === 'tablet' ? 'medium' : appDeviceType
    } else {
      if (this.scrollState.viewportWidth < 768) {
        this.scrollState.deviceType = 'mobile'
      } else if (this.scrollState.viewportWidth <= 1024) {
        this.scrollState.deviceType = 'medium'
      } else {
        this.scrollState.deviceType = 'desktop'
      }
    }
  }

  getAdjustedThreshold = () => {
    const { deviceType, zoom, threshold, element } = this.scrollState

    const deviceMultipliers = {
      mobile: 0.4,
      medium: 0.6,
      desktop: 0.8,
    }

    const screenAdjustment = deviceMultipliers[deviceType] || 1
    const zoomAdjustment = zoom < 1 ? 1 / zoom : zoom

    let dynamicThreshold = threshold
    if (element && IS_BROWSER) {
      try {
        let totalHeaderHeight = element.offsetHeight

        const mysiteShopHeader = document.querySelector('.mysite-shop-header')
        if (mysiteShopHeader) {
          totalHeaderHeight += mysiteShopHeader.offsetHeight
        }

        if (totalHeaderHeight > 100) {
          dynamicThreshold = Math.max(threshold, totalHeaderHeight * 0.4)
        }
      } catch (e) {
        dynamicThreshold = threshold
      }
    }

    return Math.round(dynamicThreshold * screenAdjustment * zoomAdjustment)
  }

  debouncedScrollHandler = () => {
    const currentScroll = application?.scroll?.vertical || 0
    const { lastPosition, deviceType, zoom, isTouchDevice, timeouts } =
      this.scrollState

    this.scrollCounter = (this.scrollCounter || 0) + 1
    if (this.scrollCounter % 100 === 0) this.initializeScrollState()

    const deltaThresholds = {
      mobile: Math.max(1, 3 / zoom),
      medium: Math.max(1.5, 4 / zoom),
      desktop: Math.max(2, 5 / zoom),
    }

    const minDelta = deltaThresholds[deviceType] || 2
    if (Math.abs(currentScroll - lastPosition) < minDelta) return

    this.scrollState.lastPosition = currentScroll

    if (timeouts.debounce) clearTimeout(timeouts.debounce)

    this.updateHeaderState(currentScroll)

    const debounceTimings = {
      mobile: 40,
      medium: isTouchDevice ? 60 : 50,
      desktop: 80,
    }

    const debounceTime = Math.max(30, debounceTimings[deviceType] * zoom)

    timeouts.debounce = setTimeout(
      () => this.finalizeHeaderState(),
      debounceTime
    )
  }

  finalizeHeaderState = () => {
    const { element, deviceType, isTouchDevice } = this.scrollState
    if (!element) return

    element.classList.remove('scroll-mobile', 'scroll-medium', 'scroll-desktop')
    element.classList.add(`scroll-${deviceType}`)

    element.classList.toggle('touch-device', isTouchDevice)
  }

  updateHeaderState = currentScroll => {
    const { element, deviceType, zoom } = this.scrollState
    if (!element) return

    const threshold = this.getAdjustedThreshold()

    const baseHysteresis = Math.max(threshold * 0.15, 8)

    let bannerBuffer = 0
    if (element) {
      const headerHeight = element.offsetHeight
      const mysiteShopHeader = document.querySelector('.mysite-shop-header')
      const hasMysiteHeader = !!mysiteShopHeader

      if (headerHeight > 100 || hasMysiteHeader) {
        bannerBuffer = hasMysiteHeader ? 8 : 5
      }
    }

    const hysteresisValues = {
      mobile: Math.max(6, baseHysteresis * 0.7, 10 / zoom) + bannerBuffer,
      medium: Math.max(8, baseHysteresis * 0.85, 12 / zoom) + bannerBuffer,
      desktop: Math.max(10, baseHysteresis, 15 / zoom) + bannerBuffer,
    }

    const hysteresis = hysteresisValues[deviceType] || baseHysteresis
    const isCurrentlyCompact = element.classList.contains('compact-view')

    const compactTrigger = threshold + hysteresis
    const fullTrigger = threshold - hysteresis

    if (currentScroll > compactTrigger && !isCurrentlyCompact) {
      element.classList.remove('full-view')
      element.classList.add('compact-view', `scroll-${deviceType}`)
      this.scrollState.headerType = 'compact-view'
    } else if (currentScroll < fullTrigger && isCurrentlyCompact) {
      element.classList.remove('compact-view')
      element.classList.add('full-view', `scroll-${deviceType}`)
      this.scrollState.headerType = 'full-view'
    }
  }

  applyInitialHeaderState = () => {
    const { element, headerType, deviceType } = this.scrollState
    if (!element) return

    element.classList.remove('full-view', 'compact-view')
    element.classList.add(headerType, `scroll-${deviceType}`)

    if (this.scrollState.isTouchDevice) {
      element.classList.add('touch-device')
    }

    this.observeHeaderHeightChanges()
  }

  observeHeaderHeightChanges = () => {
    if (!IS_BROWSER || !this.scrollState.element) return

    if (window.ResizeObserver) {
      this.headerResizeObserver = new ResizeObserver(entries => {
        if (!this._isMounted) return

        let hasSignificantChange = false
        for (let entry of entries) {
          const newHeight = entry.contentRect.height
          const oldHeight = this.scrollState.lastHeaderHeight || 0

          if (Math.abs(newHeight - oldHeight) > 5) {
            hasSignificantChange = true
            break
          }
        }

        if (hasSignificantChange) {
          const mainHeaderHeight = this.scrollState.element.offsetHeight
          const mysiteShopHeader = document.querySelector('.mysite-shop-header')
          const mysiteHeight = mysiteShopHeader
            ? mysiteShopHeader.offsetHeight
            : 0
          this.scrollState.lastHeaderHeight = mainHeaderHeight + mysiteHeight

          const currentScroll = application?.scroll?.vertical || 0
          this.updateHeaderState(currentScroll)
        }
      })

      this.headerResizeObserver.observe(this.scrollState.element)

      const mysiteShopHeader = document.querySelector('.mysite-shop-header')
      if (mysiteShopHeader) {
        this.headerResizeObserver.observe(mysiteShopHeader)
      }
    }
  }

  getMarketingData = async () => {
    let localeValue =
      this.currentLocale?.split('_')?.reverse()?.join('-') || 'US-en'
    let uid = 'bltcb3502baadc6a2d9'
    if (IS_BROWSER) {
      ContentStack.getQualificationReference(
        'header_prototype',
        uid,
        localeValue
      ).then(response => {
        if (!this._isMounted) return

        if (Object.keys(response).length > 0) {
          contentStackContainer.setMarketingData(response)
          this.topNotice = response?.emergency_statement || {}
          this.scrollingInfo =
            response?.bottom_bar_marketing_statements_carousel || []
          this.headerLogoUrl =
            response?.logo?.url[0]?.derivatives?.original || ''
          this.data = response
          footerContainer.nuskinLogoURL = this.headerLogoUrl
        }
      })
    } else {
      this.context.load(
        ContentStack.getQualificationReference(
          'header_prototype',
          uid,
          localeValue
        ).then(response => {
          return Promise.resolve({ [this.contextName]: response })
        })
      )
    }
  }

  getTopRibbonData = data => {
    const topRibbonData = data?.homepage_components?.find(
      component => component.top_ribbon
    )?.top_ribbon
    const bgColor = topRibbonData?.background_clour
    if (topRibbonData?.links?.length) {
      const [lang = 'en', country = 'us'] =
        this.currentLocale?.toLowerCase()?.split('_') || []
      const formattedItems = topRibbonData.links.map(item => {
        const rawHref = item?.link?.href || '#'
        const label = item?.link?.title || ''
        let link = rawHref

        if (rawHref.includes('{country}') || rawHref.includes('{language}')) {
          link = rawHref
            .replace('{country}', country)
            .replace('{language}', lang)
        } else if (
          rawHref.startsWith('www.') ||
          rawHref.startsWith('http://') ||
          rawHref.startsWith('https://')
        ) {
          link = rawHref.startsWith('www.') ? `https://${rawHref}` : rawHref
        }

        return { label, link, openInNewTab: item?.open_in_new_tab || false }
      })
      runInAction(() => {
        this.headerData = {
          ...this.headerData,
          topRibbon:
            this.headerData?.topRibbon?.concat(formattedItems) ||
            formattedItems,
          isTopRibbonVisible: topRibbonData?.show ?? false,
          topRibbonBackgroundColor: bgColor || '#000000',
        }
      })
    } else {
      runInAction(() => {
        if (this.headerData) {
          this.headerData.isTopRibbonVisible = topRibbonData?.show ?? false
        }
      })
    }
  }

  getHeaderData = async () => {
    const contentTypeUid = 'nextgen_homepage'
    const locale =
      this.currentLocale?.split('_')?.reverse()?.join('-') || 'US-en'
    ContentStack.getEntry(contentTypeUid, locale)
      .then(data => {
        if (!this._isMounted) return

        if (!this.headerData?.topRibbon?.length) {
          this.getTopRibbonData(data)
        }
      })
      .catch(e => {
        if (!this._isMounted) return

        console.error('Error fetching header data:', e)
        runInAction(() => {
          this.headerData = false
        })
      })
  }

  getDataFromSource = async () => {
    const marketingData = this.context?.ssrData?.marketingData || {}
    if (Object.keys(marketingData).length > 0) {
      this.data = marketingData
      contentStackContainer.setMarketingData(marketingData)
      this.topNotice = marketingData?.emergency_statement || {}
      this.scrollingInfo =
        marketingData?.bottom_bar_marketing_statements_carousel || []
      this.headerLogoUrl =
        marketingData?.logo?.url[0]?.derivatives?.original || ''
      footerContainer.nuskinLogoURL = this.headerLogoUrl
    } else {
      await this.getMarketingData()
    }
  }

  async componentDidMount() {
    super.componentDidMount()

    this._isMounted = true

    // Initialize scroll functionality immediately (don't wait for network)
    const initialScroll = application?.scroll?.vertical || 0
    this.scrollState.lastPosition = initialScroll
    this.scrollState.headerType =
      initialScroll > this.getAdjustedThreshold() ? 'compact-view' : 'full-view'

    if (IS_BROWSER && this._isMounted) {
      window.addEventListener('scroll', this.smoothScrollHandler, {
        passive: true,
      })
      window.addEventListener('resize', this.handleResize, { passive: true })
      this.eventHandlers = {
        smoothScrollHandler: this.smoothScrollHandler,
        handleResize: this.handleResize,
      }
    }
    try {
      await Promise.all([
        this.getHeaderData().catch(e =>
          console.warn('Header data fetch failed:', e)
        ),
        this.fetchHeaderData().catch(e =>
          console.warn('Fetch header data failed:', e)
        ),
      ])
    } catch (error) {
      console.error('Error in componentDidMount:', error)
    }
    setTimeout(() => {
      if (!this.scrollState.element) {
        const headerElement = document.querySelector('.nu-header-container')
        if (headerElement) {
          this.scrollState.element = headerElement
          this.applyInitialHeaderState()
        }
      }
    }, 500)
  }

  smoothScrollHandler = () => {
    if (!this.scrollState.isScrolling) {
      this.scrollState.rafId = requestAnimationFrame(() => {
        this.debouncedScrollHandler()
        this.scrollState.isScrolling = false
        this.scrollState.rafId = null
      })
      this.scrollState.isScrolling = true
    }
  }

  handleResize = () => {
    const oldState = { ...this.scrollState }
    this.initializeScrollState()

    const zoomChanged = Math.abs(oldState.zoom - this.scrollState.zoom) > 0.1
    const deviceChanged = oldState.deviceType !== this.scrollState.deviceType

    if (zoomChanged || deviceChanged) {
      const currentScroll = application?.scroll?.vertical || 0
      this.updateHeaderState(currentScroll)
    }
  }

  needsHeaderEntry = () =>
    enableNewFeature('enableRedesignMainMenu') ||
    enableNewFeature('enableContentStackBreadcrumb')

  getCsLocale = () =>
    this.currentLocale?.split('_')?.reverse()?.join('-') || 'US-en'

  // Redesigned main menu: the Contentstack `nuskin_header` entry drives the
  // category navigation. On the server the fetch joins the SSR data tree so the
  // nav is part of the HTML (an empty nav row that fills in later shifts the
  // whole page). On the client the same payload feeds the first render, so
  // hydration matches and no second fetch is needed.
  getHeaderEntryFromSource = () => {
    if (!this.needsHeaderEntry()) return
    const ssrEntry = this.context?.ssrData?.[this.headerEntryContextName]
    if (ssrEntry && Object.keys(ssrEntry).length > 0) {
      this.applyHeaderEntry(ssrEntry)
      this.headerEntryFromSSR = true
      return
    }
    if (!IS_BROWSER && typeof this.context?.load === 'function') {
      this.context.load(
        ContentStack.getEntry('nuskin_header', this.getCsLocale())
          .then(data => ({ [this.headerEntryContextName]: data || {} }))
          .catch(error => {
            console.error('Error fetching header entry for SSR:', error)
            return { [this.headerEntryContextName]: {} }
          })
      )
    }
  }

  applyHeaderEntry = data => {
    const enableRedesignMainMenu = enableNewFeature('enableRedesignMainMenu')
    const enableContentStackBreadcrumb = enableNewFeature(
      'enableContentStackBreadcrumb'
    )
    runInAction(() => {
      const rightSideBlock = data.right_side_block?.[0]
      const headerNavigation = rightSideBlock?.header_navigation
      const [lang = 'en', country = 'us'] =
        this.currentLocale?.toLowerCase()?.split('_') || []

      let navigationData = {}
      if (data && data.top_navigation) {
        navigationData = transformContentStackToMenuData(data, lang, country)

        if (
          IS_BROWSER &&
          enableContentStackBreadcrumb &&
          navigationData?.categories?.length > 0
        ) {
          const records = serializeNavigationPathRecords(
            navigationData.categories
          )
          const currentLocale = getBreadcrumbSessionRegion()
          writeBreadcrumbSessionRecord(
            'cs_navigation_data',
            records,
            currentLocale
          )
        }
      }

      if (enableRedesignMainMenu) {
        this.headerData = {
          ...this.headerData,
          regionSelector: data.region_selector,
          searchData: data.search_bar,
          navigationData: navigationData,
          headerNavigation: headerNavigation
            ? {
                link: {
                  title: headerNavigation.title_and_url?.title || '',
                  href: headerNavigation.title_and_url?.href
                    ? headerNavigation.title_and_url.href
                        .replace('{country}', country)
                        .replace('{language}', lang)
                    : '#',
                },
                usd_label: headerNavigation.usd_label || '',
              }
            : this.headerData.headerNavigation,
        }
      }
    })
  }

  fetchHeaderData = async () => {
    // Already applied from the server-rendered payload in the constructor.
    if (this.headerEntryFromSSR) return

    if (this.needsHeaderEntry()) {
      const contentTypeUid = 'nuskin_header'
      ContentStack.getEntry(contentTypeUid, this.getCsLocale())
        .then(data => {
          this.applyHeaderEntry(data)
        })
        .catch(e => {
          console.error('Error fetching header data:', e)
        })
    }
  }

  componentWillUnmount() {
    if (IS_BROWSER && this.eventHandlers) {
      window.removeEventListener(
        'scroll',
        this.eventHandlers.smoothScrollHandler
      )
      window.removeEventListener('resize', this.eventHandlers.handleResize)
    }

    if (this.scrollState.rafId) {
      cancelAnimationFrame(this.scrollState.rafId)
      this.scrollState.rafId = null
    }

    const { timeouts } = this.scrollState
    Object.values(timeouts).forEach(timeout => {
      if (timeout) clearTimeout(timeout)
    })

    this._isMounted = false

    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect()
      this.headerResizeObserver = null
    }

    this.scrollState.element = null
    this.eventHandlers = null
    this.header = null
  }

  componentDidUpdate(prevProps) {
    super.componentDidUpdate()

    const relevantPropsChanged =
      prevProps?.location?.pathname !== this.props?.location?.pathname ||
      prevProps?.location?.search !== this.props?.location?.search

    if (useStickyTop && relevantPropsChanged) {
      this.calculateHeaderSpace()
    }

    this.setupMysiteHeaderObserver()
  }

  setupMysiteHeaderObserver = () => {
    if (!IS_BROWSER || !this.headerResizeObserver) return

    const mysiteShopHeader = document.querySelector('.mysite-shop-header')
    const wasObserving = this.mysiteHeaderObserved || false
    const shouldObserve = !!mysiteShopHeader

    if (wasObserving !== shouldObserve) {
      this.headerResizeObserver.disconnect()
      this.mysiteHeaderObserved = shouldObserve

      if (this.scrollState.element) {
        this.headerResizeObserver.observe(this.scrollState.element)
      }

      if (mysiteShopHeader) {
        this.headerResizeObserver.observe(mysiteShopHeader)
      }

      const currentScroll = application?.scroll?.vertical || 0
      this.updateHeaderState(currentScroll)
    }
  }

  initializeScrolling = () => {
    if (!IS_BROWSER) return
    const headerElement =
      this.header || document.querySelector('.nu-header-container')

    if (headerElement && !this.scrollState.element) {
      this.scrollState.element = headerElement
      this.applyInitialHeaderState()
      const currentScroll =
        application?.scroll?.vertical || window.pageYOffset || 0
      this.updateHeaderState(currentScroll)
    }
  }

  getqualification = async () => {
    const role = getCookie('x-role-user') || false
    if (role) {
      await customerContainer.qualificationUser()
    }
  }

  getQualificationUrl = () => {
    return QUALIFICATION_URL + this.currentLocale
  }

  showCookieStatus = () => {
    if (IS_BROWSER && !navigator.cookieEnabled) {
      return (
        <div className="no-cookie">
          {i18nTranslate(
            'cookie.disabled',
            'This website requires cookie to work properly. To continue, please enable cookie in your browser.',
            { nameSpace: this.nameSpace }
          )}
        </div>
      )
    }
    return ''
  }

  render() {
    if (shouldSuppressHeaderAndModals(this.props.location)) {
      return <></>
    }
    const enableKlarnaHomeMessage =
      getAppConfig()?.enableHeaderOption == 'klarna'
    const enableMarketingMessage =
      getAppConfig()?.enableHeaderOption == 'marketing'
    const handleSkipLink = () => {
      if (IS_BROWSER) {
        window.scrollTo(0, 0)
      }
    }
    const isProductOfferPage =
      this.props?.location?.pathname === pageNames.productOfferAdmin
    const skipToMainTarget = isProductOfferPage
      ? '#product-offer-container'
      : '#id-app-wrapper'
    const isSubscriptionOverridePage = isToShowOverrideSubscription()
    const headerSearchClassName = searchState.isSearchFocused
      ? 'search-focused'
      : ''

    // Add specific class for iPad Pro (1024px) to handle header hiding
    const isIpadPro = IS_BROWSER && window.innerWidth === 1024
    const ipadProSearchClass =
      searchState.isSearchFocused && isIpadPro ? 'search-focused-ipad-pro' : ''

    const headerClass = this.scrollState.headerType
    const stickyTop = application?.scroll?.vertical || 0
    const mysiteNavigation = mysiteContainer.mysiteSkipNavigation
    return (
      <header
        x={stickyTop}
        className={`nu-header-container w-100 ${headerSearchClassName} ${ipadProSearchClass} ${headerClass} ${isSubscriptionOverridePage ? 'disable-override-header' : ''}`}
        style={
          this.props?.isMySite
            ? {
                transition:
                  this.scrollState.deviceType === 'medium'
                    ? 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                    : 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                transform: 'translateZ(0)',
                backfaceVisibility: 'hidden',
                ...(this.scrollState.isTouchDevice && {
                  WebkitTransform: 'translate3d(0,0,0)',
                }),
              }
            : {}
        }
        ref={element => {
          if (
            this.scrollState.element &&
            this.scrollState.element !== element
          ) {
            this.scrollState.element = null
          }

          this.header = element
          this.scrollState.element = element

          if (element) {
            this.applyInitialHeaderState()
            setTimeout(() => {
              if (!this.scrollState.isScrolling) {
                this.initializeScrolling()
              }
            }, 1000)
          }
        }}>
        <noscript>
          <div className="no-script">
            {i18nTranslate(
              'script.disabled',
              'This website requires JavaScript to work properly. To continue, please enable JavaScript in your browser.',
              { nameSpace: this.nameSpace }
            )}
          </div>
        </noscript>
        {this.showCookieStatus()}
        <KlarnaScript />
        <Row noGutters className="w-100">
          {this.renderAdminTopBar()}
        </Row>
        <div className="bg-white">
          <SkipLink
            className={`skip-link text-primary bg-white ${enableNewFeature('enableNewTopRibbon') ? 'skip-link-new-top-ribbon' : ''}`}
            skipTo=".navigationContainerItem">
            <a href="#">
              {i18nTranslate('skipNav', 'Skip to navigation', {
                nameSpace: this.nameSpace,
              })}
            </a>
          </SkipLink>
          {isEquinoxMysite() && (
            <>
              {mysiteNavigation.showBannner && (
                <SkipLink
                  className={`skip-link text-primary bg-white ${enableNewFeature('enableNewTopRibbon') ? 'skip-link-new-top-ribbon' : ''}`}
                  skipTo=".mysite-shop-header">
                  <a href="#">
                    {i18nTranslate('skipShopBanner', 'Skip to Shop Banner', {
                      nameSpace: this.nameSpace,
                    })}
                  </a>
                </SkipLink>
              )}
              {mysiteNavigation.customCategory && (
                <SkipLink
                  className={`skip-link text-primary bg-white ${enableNewFeature('enableNewTopRibbon') ? 'skip-link-new-top-ribbon' : ''}`}
                  skipTo=".product-tab-carousal-wrapper">
                  <a href="#">
                    {i18nTranslate(
                      'skipCustomCategory',
                      'Skip to Custom Category',
                      {
                        nameSpace: this.nameSpace,
                      }
                    )}
                  </a>
                </SkipLink>
              )}
            </>
          )}
          <SkipLink
            handleClick={handleSkipLink}
            className={`skip-link text-primary bg-white ${enableNewFeature('enableNewTopRibbon') ? 'skip-link-new-top-ribbon' : ''}`}
            skipTo={skipToMainTarget}>
            <a href="#">
              {i18nTranslate('skipMain', 'Skip to main content', {
                nameSpace: this.nameSpace,
              })}
            </a>
          </SkipLink>
          <SkipLink
            className={`skip-link text-primary bg-white ${enableNewFeature('enableNewTopRibbon') ? 'skip-link-new-top-ribbon' : ''}`}
            skipTo="#id-footer-container">
            <a href="#">
              {i18nTranslate('skipFooter', 'Skip to footer', {
                nameSpace: this.nameSpace,
              })}
            </a>
          </SkipLink>
        </div>
        {this.topNotice?.title && <TopNotice topNotice={this.topNotice} />}
        {/* klarna message */}
        {enableKlarnaHomeMessage && (
          <div
            className={`${
              isHomePage(this.props) && enableKlarnaHomeMessage
                ? 'home-klarna-top-strip-height'
                : 'home-klarna-top-strip'
            }`}>
            <KlarnaMessage
              id="klarna-home-top-strip"
              data-key="top-strip-promotion-auto-size"
              isFromHomePage={true}
              {...this.props}></KlarnaMessage>
          </div>
        )}
        {enableMarketingMessage && isHomePage(this.props) && (
          <HeaderMarketing {...this.props} marketingData={this.data} />
        )}
        {/* <LocaleSection {...this.props} /> */}
        {!searchState.isSearchFocused &&
          enableNewFeature('enableNewTopRibbon') &&
          this.headerData?.isTopRibbonVisible && (
            <TopRibbon
              items={this.headerData.topRibbon}
              backgroundColor={this.headerData.topRibbonBackgroundColor}
            />
          )}
        <SearchSection
          {...this.props}
          headerLogoUrl={this.headerLogoUrl}
          {...(enableNewFeature('enableNewHeaderNavigation')
            ? {
                headerNavigation: this.headerData.headerNavigation,
                regionSelector: this.headerData.regionSelector,
                searchData: this.headerData.searchData,
              }
            : {})}
        />
        {(!isEquinoxPOSite() ||
          convertToBoolean(
            APPConfig?.getAppConfig()?.enableDotComHeaderForProductOffer
          )) && (
          <MegaMenuSection
            {...this.props}
            // data={this.data}
            categoryResponse={this.categoryResponse}
            {...(enableNewFeature('enableNewHeaderNavigation')
              ? {
                  headerNavigation: this.headerData.headerNavigation,
                  regionSelector: this.headerData.regionSelector,
                }
              : {})}
            {...(enableNewFeature('enableRedesignMainMenu')
              ? {
                  navigationData: this.headerData.navigationData,
                }
              : {})}
          />
        )}
        {/* Scrolling section is removed with new May 2025 Design */}
        {/* {this.scrollingInfo?.length > 0 && (
          <ScrollingInfoSection scrollingInfo={this.scrollingInfo} /> 
        )} */}
        <Container fluid>
          <Row>
            <Col className="p-0">
              {customerContainer?.qualificationResponse
                ?.isQualificationEligible === true &&
                customerContainer?.qualificationStoreResponse === true && (
                  <div className="header-preview-text">
                    <p className="paragraph-s">
                      <span>
                        <img src={leadership} className="pr-1" alt="" />
                      </span>
                      {customerContainer?.qualificationData
                        ?.early_access_message || ''}

                      <a
                        href={this.getQualificationUrl()}
                        className="paragraph-s-underline pl-1"
                        //CX121-4490 - Open link in same tab
                        // target="_blank"
                        rel="noreferrer">
                        {customerContainer?.qualificationData
                          ?.early_access_link || ''}
                      </a>
                    </p>
                  </div>
                )}
            </Col>
          </Row>
        </Container>
        {this.props.isMySiteorPOSite && (
          <MysiteShopHeader isMySiteorPOSite={this.props.isMySiteorPOSite} />
        )}
      </header>
    )
  }
}

export default withRouter(NuskinHeader)
